export default {
  baseStyle: {
    fontWeight: 'bold',
    marginRight: 0,
  },
};
